import { Globe, Check } from "lucide-react";
import { useI18n } from "@/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LABELS = { de: "Deutsch", en: "English", es: "Español", fr: "Français" };

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className="flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1.5 text-xs font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          <Globe className="h-4 w-4" />
          <span className="uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {langs.map((l) => (
          <DropdownMenuItem key={l} onClick={() => setLang(l)} data-testid={`lang-${l}`} className="justify-between">
            {LABELS[l]}
            {lang === l && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { LABELS as LANGUAGE_LABELS };
